import React, { useEffect } from 'react'
import Page from '../Page/Page'
import classes from './Documents.module.css'
import { polyfill, scrollIntoView, scrollTo, elementScrollIntoView } from 'seamless-scroll-polyfill'
import { useSearchParams } from 'react-router-dom'

const Documents = () => {
    polyfill()
    const [searchParams, setSearchParams] = useSearchParams()
    useEffect(() => {
        const query = window.location.search.split('=')[1]
        if (query) {
            if (query === 'delivery') window.scrollTo(0, 0)
            else {
                const block = document.querySelector(`span[data-block="${query}"]`)
                block?.scrollIntoView(true)
            }
            // if (block) {
            //     scrollIntoView(block, { behavior: 'smooth' })
            // }
            // window.scrollBy(0, -100)
        }
    }, [])

    useEffect(() => {
        const query = searchParams.get('block')
        if (query) {
            if (query === 'delivery') window.scrollTo(0, 0)
            else {
                const block = document.querySelector(`span[data-block="${query}"]`)
                block?.scrollIntoView(true)
            }

            // if (block) {
            //     elementScrollIntoView(block, { behavior: 'smooth' })
            // }
        }
    }, [searchParams])

    const onClick = (e: React.MouseEvent, name: string) => {
        // e.preventDefault()
        // const block = document.querySelector(`span[data-block="${name}"]`)
        // console.log(block)

        // if (block) {
        //     scrollIntoView(block, { behavior: 'smooth' })
        // }
        setSearchParams({ block: name })
        // window.scrollBy(0, -100)
    }

    return (
        <Page>
            <div className={classes.documents}>
                <div className={classes.header}>
                    <div className={classes.empty} />
                    <h2>Документы сайта</h2>
                    <div />
                </div>

                <div className={classes.content}>
                    <nav className={classes.nav}>
                        <h3 onClick={(e) => onClick(e, 'delivery')}>Доставка &#8594;</h3>
                        <h3 onClick={(e) => onClick(e, 'reqs')}>Реквизиты &#8594;</h3>
                        <h3 onClick={(e) => onClick(e, 'offer')}>Договор оферты &#8594;</h3>
                        <h3 onClick={(e) => onClick(e, 'policy')}>
                            Конфиденциальность и защита информации &#8594;
                        </h3>
                        <h3 onClick={(e) => onClick(e, 'return')}>
                            Правила возврата товара &#8594;
                        </h3>
                        <h3 onClick={(e) => onClick(e, 'loyalty')}>
                            О программе лояльности &#8594;
                        </h3>
                        {/*<h3 onClick={e => onClick(e,"certs")}>Сертификаты &#8594;</h3>*/}
                    </nav>
                    <div className={classes.text}>
                        <span data-block='delivery' />
                        <h2>Доставка</h2>
                        <ul>
                            <li>
                                Самовывоз - бесплатно ( возможен только для городов, где есть
                                магазины Elixiroom);
                            </li>
                            <li>
                                Доставка почта/сдэк осуществляется до пункта выдачи, согласно
                                ближайшему адресу, указанному при заказе, если сумма заказа больше
                                3000 рублей - доставка бесплатно.
                                <br />
                                Если сумма заказа менее 3000 рублей, то стоимость доставки 300
                                рублей;
                            </li>
                            <li>
                                Доставка курьером (срочная) для заказов оформленных до 17.00 - 450
                                рублей, в течении дня - 300 рублей.
                                <br />
                                Доставка курьером доступна только для городов, где есть магазины
                                Elixiroom.
                            </li>
                        </ul>
                        <span
                            style={{ display: 'block', width: 10, height: 10, marginBottom: '8em' }}
                            data-block='reqs'
                        />
                        {/* <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br /> */}
                        <h2>Реквизиты</h2>
                        <p>
                            ИП ЧУХ ДАРЬЯ ИГОРЕВНА
                            <br />
                            ИНН: 220419122502
                            <br />
                            ОГРН/ОГРНИП: 323220200062232
                            <br />
                            Рассчетный счёт: 40802810500005267024
                            <br />
                            Банк: АО "ТБанк"
                            <br />
                            {/* Адрес: 366022, РОССИЯ, Чеченская Респ, г Аргун, село Чечен-Аул, ул
                            им.Чими Дуки, д 24, кв 2 */}
                        </p>
                        <span
                            style={{ display: 'block', width: 10, height: 10, marginBottom: '8em' }}
                            data-block='offer'
                        />
                        {/* <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br /> */}
                        <h2>Договор оферты</h2>
                        <h3>Основные понятия</h3>
                        <p>
                            Пользователь — физическое лицо, посетитель Сайта, принимающий условия
                            настоящего Соглашения и желающий разместить Заказы на сайте
                            https://elixiroom.ru
                        </p>
                        <p>
                            Покупатель — Пользователь, разместивший Заказ на сайте
                            https://elixiroom.ru
                        </p>
                        <p>
                            Интернет-магазин — Интернет-сайт https://elixiroom.ru, принадлежащий
                            Продавцу, расположенный в сети интернет по адресу https://elixiroom.ru,
                            где представлены Товары, предлагаемые Продавцом для приобретения, а
                            также условия оплаты и доставки Товаров Покупателям.
                        </p>
                        <p>Сайт — https://elixiroom.ru</p>
                        <p>Товар — сертификаты на селективную парфюмерию, селективная парфюмерия</p>
                        <p>
                            Заказ — должным образом оформленный запрос Покупателя на приобретение и
                            доставку по указанному Покупателем адресу и Товаров, выбранных на Сайте.
                        </p>
                        <h3>1. Общие положения</h3>
                        <div>
                            1.1. Продавец осуществляет продажу Товаров через интернет-магазин,
                            расположенный по адресу: https://elixiroom.ru
                            <br />
                            1.2. Предложенные на Сайте условия продажи Товаров, включая всю
                            информацию о Товаре, способах и сроках его доставки, оплаты и получения,
                            размещенные на Сайте, представляют из себя Договор Оферты.
                            <br />
                            1.3. Осуществляя Заказ Товара через интернет-магазин, Пользователь
                            принимает условия Договора Оферты и условия продажи Товара, отраженные в
                            разделах 2-11 Договора Оферты. Отказ от принятия условий Договора Оферты
                            и условий продажи Товара возлагает на Пользователя обязанность перестать
                            использовать Сайт.
                            <br />
                            1.4. Договор Оферты в целом или в части может быть изменен Продавцом в
                            одностороннем порядке, уведомление Пользователя/Покупателя о
                            произведенных изменениях не требуется. Принимая условия настоящего
                            Договора Оферты, Пользователь/Покупатель соглашается, что внесенные
                            Продавцом изменения вступают в силу в течение 1 (Одного) календарного
                            дня с момента совершения публикации новой редакции Договора Оферты на
                            Сайте.
                            <br />
                            1.5. Оферта признается акцептованной (принятой)
                            Пользователем/Покупателем с момента выполнения одного из следующих
                            условий:
                            <ul>
                                <li>
                                    оформления Заказа посредством общения с менеджерами
                                    интернет-магазина по номерам телефонов, указанным на Сайте;
                                </li>
                                <li>
                                    осуществление Заказа посредством адреса электронной почты
                                    интернет-магазина
                                </li>
                                <li>
                                    регистрации на Сайте или добавлении необходимого Товара в
                                    корзину Покупателя;
                                </li>
                            </ul>
                        </div>
                        <h3>2. Предмет соглашения</h3>
                        <p>
                            2.1. Настоящий Договор Оферты регулирует взаимоотношения по оказанию
                            услуг Пользователю Сайта/Покупателю, связанные с заказом и приобретением
                            размещенного на Сайте ассортимента Товаров. Договор Оферты
                            распространяется на взаимоотношения Продавца и Пользователя/Покупателя
                            по вопросам ознакомления с информацией о Товаре, размещенном для продажи
                            на Сайте, заказа Товара, а также приобретения Товара с целью потребления
                            для личных и иных, тесно связанных с ними нужд, не в целях
                            предпринимательства. Данный Договор Оферты не является предложением о
                            заключении договора поставки Товара за пределы г. Москвы.
                            <br />
                            2.2. Действие Договора Оферты распространяется на весь ассортимент
                            Товаров и услуг, размещенных на Сайте.
                        </p>
                        <h3>3. Оформление заказа, регистрация на сайте</h3>
                        <div>
                            3.1. Заказ Товара Пользователем осуществляется посредством телефонного
                            общения с менеджерами интернет-магазина, а также через сервисы
                            электронной почты ru или путем добавления товара в корзину на Сайте.
                            <br />
                            33.3. Для оформления Заказа или обеспечения возможности правильного
                            выбора Товара, уточнения способов оплаты и доставки Товара, ответов на
                            иные возможные вопросы (комментарии, предложения, отзывы и пр.)
                            Пользователю необходимо предоставить информацию о своем имени, номере
                            контактного телефона для связи и адресе электронной почты. Сообщая
                            вышеуказанную информацию, Пользователь/Покупатель дает свое согласие на
                            использование данной информации в следующих целях:
                            <ul>
                                <li>
                                    для осуществления связи с Пользователем/Покупателем в целях
                                    исполнения предмета настоящего договора Оферты;
                                </li>

                                <li>
                                    в целях распространения информации о торговых акциях
                                    интернет-магазина https://elixiroom.ru
                                </li>

                                <li>
                                    иных целях, указанных в Положении о защите персональных данных и
                                    конфиденциальности информации.
                                </li>
                            </ul>
                            3.4. Пользователь/Покупатель полностью отвечает за достоверность
                            информации, предоставленной Продавцу.
                        </div>
                        <h3>4. Порядок совершения покупки</h3>
                        <div>
                            4.1. Информация о Товарах (об Изготовителе, технических характеристиках,
                            основных потребительских свойствах, сроке годности, правилах безопасного
                            использования Товара, о месте изготовления Товара, о полном фирменном
                            наименовании (наименовании) изготовителя, о цене и об условиях
                            приобретения Товара, о его доставке, о порядке оплаты Товара и пр. ),
                            обеспечивающая возможность их правильного выбора, размещена на Сайте и
                            может быть указана в документации, прилагаемой к Товарам, на этикетках,
                            маркировкой или иным способом, а также может быть предоставлена устно,
                            письменно или лично, по требованию Пользователя Сайта/Покупателя.
                            <br />
                            4.2. Руководствуясь п. 1.5 настоящего Договора Оферты, приобретение
                            Товара Пользователем Сайта осуществляется, в том числе посредством
                            телефонного общения. Стороны Договора Оферты приходят к соглашению, что
                            взаимное общение Пользователя/Покупателя и менеджеров интернет-магазина
                            должно строиться на принципах уважения чести, достоинства и деловой
                            репутации. Стороны Договора Оферты предупреждены о гражданской,
                            административной и уголовной ответственности за причинение оскорблений,
                            угроз и прочих форм неэтичного поведения, способных попасть под
                            классификацию правонарушения/преступления.
                            <br />
                            4.3. Принимая условия настоящего Договора Оферты, Пользователь
                            Сайта/Покупатель соглашается, что порядок обработки Заказа
                            интернет-магазином и исполнение Продавцом обязательств по приобретению
                            Товара Пользователем/Покупателем может состоять из следующих этапов:
                            <ul>
                                <li>
                                    ознакомление Гостя Сайта/Пользователя/Покупателя с информацией,
                                    размещенной на Сайте, пребывание на сайте;
                                </li>
                                <li>
                                    консультирование Пользователя/Покупателя сотрудниками
                                    интернет-магазина по вопросам оформления Заказа и приобретения
                                    Товара, способах его оплаты и доставки;
                                </li>
                                <li>
                                    получение согласия Пользователя/Покупателя на приобретение
                                    заказанного им Товара (согласие Пользователя/Покупателя может
                                    быть выражено тем же способом, каким сделан Заказ Товара),
                                    принятие интернет-магазином Заявки;
                                </li>
                                <li>
                                    после оформления Заказа менеджер интернет-магазина,
                                    обслуживающий данный Заказ, вправе уточнить детали Заказа,
                                    согласовывать дату доставки или интервал предполагаемых дат
                                    доставки. Сроки доставки Товара зависят от типа доставки,
                                    выбранного Пользователем/Покупателем и Региона доставки.
                                    уведомление Пользователя/Покупателя о предполагаемой дате
                                    (интервале дат) доставки Товара осуществляется посредством
                                    телефонной связи или путем направления электронного сообщения по
                                    адресу, указанному Пользователем/Покупателем. При осуществлении
                                    связи с Пользователем/Покупателем со стороны менеджера
                                    интернет-магазина устанавливается ограничение по количеству
                                    телефонных звонков/sms в отношении каждого Заказа Товара
                                    Пользователем/Покупателем в количестве 10(десять) повторений или
                                    не более 3 (трех) календарных дней подряд в случае, если связь с
                                    Пользователем/Покупателем отсутствует;
                                </li>
                                <li>
                                    осуществление процедуры приема-передачи Товара Пользователю
                                    Сайта/Покупателю в случае самовывоза или контроль за
                                    приемом-передачей заказанного Товара в Регион;
                                </li>
                                <li>урегулирование разногласий.</li>
                            </ul>
                            4.4. Способы оплаты Товара, заказанного на Сайте, регламентированы
                            Разделом 6 настоящего Договора Оферты.
                            <br />
                            4.5. Способы доставки Товара, заказанного на Сайте, регламентированы
                            Разделом 5 настоящего договора публичной оферты.
                        </div>
                        <h3>5. Оплата товара</h3>
                        <div>
                            6.1. Оплата Товара осуществляется путем использования национальных
                            платежных инструментов, а также наличных расчетов. Договором Оферты
                            устанавливаются следующие способы оплаты Товара Покупателем:
                            <ul>
                                <li>оплата Товара наличными денежными средствами при получении;</li>
                                <li>оплата банковским переводом на расчетный счет Продавца;</li>
                                <li>оплата Товара банковской картой на Сайте;</li>
                                <li>
                                    оплата товара с помощью электронных сервисов «Яндекс. Деньги»;
                                </li>
                            </ul>
                            Перечень доступных способов оплаты может быть расширен Продавцом в
                            одностороннем порядке без предварительного уведомления.
                            <br />
                            6.2. В соответствии с гражданским законодательством РФ, валютой
                            совершения денежных операций является российский рубль.
                            <br />
                            6.3. Цена Товара указывается Продавцом на Сайте.
                            <br />
                            6.4. Особенности оплаты Товара с помощью банковских карт:
                            <ul>
                                <li>
                                    в соответствии с положением Центрального Банка РФ от
                                    24.12.2004г. № 266-П «Об эмиссии банковских карт и об операциях,
                                    совершаемых с использованием платежных карт» операции по
                                    банковским картам совершаются держателем карты либо
                                    уполномоченным им лицом, Пользователь/Покупатель гарантирует,
                                    что является законным владельцем используемой им для оплаты
                                    банковской карты и действует добросовестно;
                                </li>
                                <li>
                                    авторизация операций по банковским картам осуществляется банком.
                                    Если у банка есть основания полагать, что операция носит
                                    мошеннический характер, то банк вправе отказать в осуществлении
                                    данной операции;
                                </li>
                                <li>
                                    в случаях, установленных законодательством, все Заказы,
                                    оформленные на Сайте и предоплаченные банковской картой, во
                                    избежание различного рода неправомерного использования
                                    банковских карт при оплате, могут быть проверены Продавцом в
                                    целях проверки личности владельца и его правомочности на
                                    использование карты. Продавец вправе потребовать от Покупателя,
                                    оформившего такой Заказ, предъявления документа, удостоверяющего
                                    личность.
                                </li>
                            </ul>
                        </div>
                        <span
                            style={{ display: 'block', width: 10, height: 10, marginBottom: '8em' }}
                            data-block='policy'
                        />
                        {/* <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br /> */}
                        <h2>Конфиденциальность и защита информации</h2>
                        <div>
                            <p>1. Общие положения</p>
                            <p>
                                Настоящая политика обработки персональных данных составлена
                                в соответствии с требованиями Федерального закона от 27.07.2006.
                                № 152-ФЗ «О персональных данных» (далее — Закон о персональных
                                данных) и определяет порядок обработки персональных данных и меры
                                по обеспечению безопасности персональных данных, предпринимаемые
                                Моисеев Константин Сергеевич (далее — Оператор).
                            </p>
                            <p>
                                1.1. Оператор ставит своей важнейшей целью и условием осуществления
                                своей деятельности соблюдение прав и свобод человека и гражданина
                                при обработке его персональных данных, в том числе защиты прав
                                на неприкосновенность частной жизни, личную и семейную тайну.
                            </p>
                            <p>
                                1.2. Настоящая политика Оператора в отношении обработки персональных
                                данных (далее — Политика) применяется ко всей информации, которую
                                Оператор может получить о посетителях веб-сайта
                                https://elixiroom.ru.
                            </p>

                            <p>2. Основные понятия, используемые в Политике</p>
                            <p>
                                2.1. Автоматизированная обработка персональных данных — обработка
                                персональных данных с помощью средств вычислительной техники.
                            </p>
                            <p>
                                2.2. Блокирование персональных данных — временное прекращение
                                обработки персональных данных (за исключением случаев, если
                                обработка необходима для уточнения персональных данных).
                            </p>
                            <p>
                                2.3. Веб-сайт — совокупность графических и информационных
                                материалов, а также программ для ЭВМ и баз данных, обеспечивающих
                                их доступность в сети интернет по сетевому адресу
                                https://elixiroom.ru.
                            </p>
                            <p>
                                2.4. Информационная система персональных данных — совокупность
                                содержащихся в базах данных персональных данных и обеспечивающих
                                их обработку информационных технологий и технических средств.
                            </p>
                            <p>
                                2.5. Обезличивание персональных данных — действия, в результате
                                которых невозможно определить без использования дополнительной
                                информации принадлежность персональных данных конкретному
                                Пользователю или иному субъекту персональных данных.
                            </p>
                            <p>
                                2.6. Обработка персональных данных — любое действие (операция) или
                                совокупность действий (операций), совершаемых с использованием
                                средств автоматизации или без использования таких средств
                                с персональными данными, включая сбор, запись, систематизацию,
                                накопление, хранение, уточнение (обновление, изменение), извлечение,
                                использование, передачу (распространение, предоставление, доступ),
                                обезличивание, блокирование, удаление, уничтожение персональных
                                данных.
                            </p>
                            <p>
                                2.7. Оператор — государственный орган, муниципальный орган,
                                юридическое или физическое лицо, самостоятельно или совместно
                                с другими лицами организующие и/или осуществляющие обработку
                                персональных данных, а также определяющие цели обработки
                                персональных данных, состав персональных данных, подлежащих
                                обработке, действия (операции), совершаемые с персональными данными.
                            </p>
                            <p>
                                2.8. Персональные данные — любая информация, относящаяся прямо или
                                косвенно к определенному или определяемому Пользователю веб-сайта
                                https://elixiroom.ru.
                            </p>
                            <p>
                                2.9. Персональные данные, разрешенные субъектом персональных данных
                                для распространения, — персональные данные, доступ неограниченного
                                круга лиц к которым предоставлен субъектом персональных данных путем
                                дачи согласия на обработку персональных данных, разрешенных
                                субъектом персональных данных для распространения в порядке,
                                предусмотренном Законом о персональных данных (далее — персональные
                                данные, разрешенные для распространения).
                            </p>
                            <p>
                                2.10. Пользователь — любой посетитель веб-сайта
                                https://elixiroom.ru.
                            </p>
                            <p>
                                2.11. Предоставление персональных данных — действия, направленные
                                на раскрытие персональных данных определенному лицу или
                                определенному кругу лиц.
                            </p>
                            <p>
                                2.12. Распространение персональных данных — любые действия,
                                направленные на раскрытие персональных данных неопределенному кругу
                                лиц (передача персональных данных) или на ознакомление
                                с персональными данными неограниченного круга лиц, в том числе
                                обнародование персональных данных в средствах массовой информации,
                                размещение в информационно-телекоммуникационных сетях или
                                предоставление доступа к персональным данным каким-либо иным
                                способом.
                            </p>
                            <p>
                                2.13. Трансграничная передача персональных данных — передача
                                персональных данных на территорию иностранного государства органу
                                власти иностранного государства, иностранному физическому или
                                иностранному юридическому лицу.
                            </p>
                            <p>
                                2.14. Уничтожение персональных данных — любые действия, в результате
                                которых персональные данные уничтожаются безвозвратно
                                с невозможностью дальнейшего восстановления содержания персональных
                                данных в информационной системе персональных данных
                                и/или уничтожаются материальные носители персональных данных.
                            </p>

                            <p>3. Основные права и обязанности Оператора</p>
                            <p>3.1. Оператор имеет право:</p>
                            <p>
                                — получать от субъекта персональных данных достоверные информацию
                                и/или документы, содержащие персональные данные;
                            </p>
                            <p>
                                — в случае отзыва субъектом персональных данных согласия
                                на обработку персональных данных, а также, направления обращения
                                с требованием о прекращении обработки персональных данных, Оператор
                                вправе продолжить обработку персональных данных без согласия
                                субъекта персональных данных при наличии оснований, указанных
                                в Законе о персональных данных;
                            </p>
                            <p>
                                — самостоятельно определять состав и перечень мер, необходимых
                                и достаточных для обеспечения выполнения обязанностей,
                                предусмотренных Законом о персональных данных и принятыми
                                в соответствии с ним нормативными правовыми актами, если иное
                                не предусмотрено Законом о персональных данных или другими
                                федеральными законами.
                            </p>
                            <p>3.2. Оператор обязан:</p>
                            <p>
                                — предоставлять субъекту персональных данных по его просьбе
                                информацию, касающуюся обработки его персональных данных;
                            </p>
                            <p>
                                — организовывать обработку персональных данных в порядке,
                                установленном действующим законодательством РФ;
                            </p>
                            <p>
                                — отвечать на обращения и запросы субъектов персональных данных
                                и их законных представителей в соответствии с требованиями Закона
                                о персональных данных;
                            </p>
                            <p>
                                — сообщать в уполномоченный орган по защите прав субъектов
                                персональных данных по запросу этого органа необходимую информацию
                                в течение 10 дней с даты получения такого запроса;
                            </p>
                            <p>
                                — публиковать или иным образом обеспечивать неограниченный доступ
                                к настоящей Политике в отношении обработки персональных данных;
                            </p>
                            <p>
                                — принимать правовые, организационные и технические меры для защиты
                                персональных данных от неправомерного или случайного доступа к ним,
                                уничтожения, изменения, блокирования, копирования, предоставления,
                                распространения персональных данных, а также от иных неправомерных
                                действий в отношении персональных данных;
                            </p>
                            <p>
                                — прекратить передачу (распространение, предоставление, доступ)
                                персональных данных, прекратить обработку и уничтожить персональные
                                данные в порядке и случаях, предусмотренных Законом о персональных
                                данных;
                            </p>
                            <p>
                                — исполнять иные обязанности, предусмотренные Законом о персональных
                                данных.
                            </p>
                            <p>4. Основные права и обязанности субъектов персональных данных</p>
                            <p>4.1. Субъекты персональных данных имеют право:</p>
                            <p>
                                — получать информацию, касающуюся обработки его персональных данных,
                                за исключением случаев, предусмотренных федеральными законами.
                                Сведения предоставляются субъекту персональных данных Оператором
                                в доступной форме, и в них не должны содержаться персональные
                                данные, относящиеся к другим субъектам персональных данных,
                                за исключением случаев, когда имеются законные основания для
                                раскрытия таких персональных данных. Перечень информации и порядок
                                ее получения установлен Законом о персональных данных;
                            </p>
                            <p>
                                — требовать от оператора уточнения его персональных данных,
                                их блокирования или уничтожения в случае, если персональные данные
                                являются неполными, устаревшими, неточными, незаконно полученными
                                или не являются необходимыми для заявленной цели обработки, а также
                                принимать предусмотренные законом меры по защите своих прав;
                            </p>
                            <p>
                                — выдвигать условие предварительного согласия при обработке
                                персональных данных в целях продвижения на рынке товаров, работ
                                и услуг;
                            </p>
                            <p>
                                — на отзыв согласия на обработку персональных данных, а также,
                                на направление требования о прекращении обработки персональных
                                данных;
                            </p>
                            <p>
                                — обжаловать в уполномоченный орган по защите прав субъектов
                                персональных данных или в судебном порядке неправомерные действия
                                или бездействие Оператора при обработке его персональных данных;
                            </p>
                            <p>
                                — на осуществление иных прав, предусмотренных законодательством РФ.
                            </p>
                            <p>4.2. Субъекты персональных данных обязаны:</p>
                            <p>— предоставлять Оператору достоверные данные о себе;</p>
                            <p>
                                — сообщать Оператору об уточнении (обновлении, изменении) своих
                                персональных данных.
                            </p>
                            <p>
                                4.3. Лица, передавшие Оператору недостоверные сведения о себе, либо
                                сведения о другом субъекте персональных данных без согласия
                                последнего, несут ответственность в соответствии
                                с законодательством РФ.
                            </p>
                            <p>5. Принципы обработки персональных данных</p>
                            <p>
                                5.1. Обработка персональных данных осуществляется на законной
                                и справедливой основе.
                            </p>
                            <p>
                                5.2. Обработка персональных данных ограничивается достижением
                                конкретных, заранее определенных и законных целей. Не допускается
                                обработка персональных данных, несовместимая с целями сбора
                                персональных данных.
                            </p>
                            <p>
                                5.3. Не допускается объединение баз данных, содержащих персональные
                                данные, обработка которых осуществляется в целях, несовместимых
                                между собой.
                            </p>
                            <p>
                                5.4. Обработке подлежат только персональные данные, которые отвечают
                                целям их обработки.
                            </p>
                            <p>
                                5.5. Содержание и объем обрабатываемых персональных данных
                                соответствуют заявленным целям обработки. Не допускается
                                избыточность обрабатываемых персональных данных по отношению
                                к заявленным целям их обработки.
                            </p>
                            <p>
                                5.6. При обработке персональных данных обеспечивается точность
                                персональных данных, их достаточность, а в необходимых случаях
                                и актуальность по отношению к целям обработки персональных данных.
                                Оператор принимает необходимые меры и/или обеспечивает их принятие
                                по удалению или уточнению неполных или неточных данных.
                            </p>
                            <p>
                                5.7. Хранение персональных данных осуществляется в форме,
                                позволяющей определить субъекта персональных данных, не дольше, чем
                                этого требуют цели обработки персональных данных, если срок хранения
                                персональных данных не установлен федеральным законом, договором,
                                стороной которого, выгодоприобретателем или поручителем по которому
                                является субъект персональных данных. Обрабатываемые персональные
                                данные уничтожаются либо обезличиваются по достижении целей
                                обработки или в случае утраты необходимости в достижении этих целей,
                                если иное не предусмотрено федеральным законом.
                            </p>

                            <p>6. Цели обработки персональных данных</p>
                            <p>
                                Цель обработки: информирование Пользователя посредством отправки
                                электронных писем
                            </p>
                            <p>
                                Персональные данные: фамилия, имя, отчество, электронный адрес,
                                номера телефонов, год, месяц, дата и место рождения
                            </p>
                            <p>
                                Правовые основания: договоры, заключаемые между оператором и
                                субъектом персональных данных
                            </p>
                            <p>
                                Виды обработки персональных данных: Сбор, запись, систематизация,
                                накопление, хранение, уничтожение и обезличивание персональных
                                данных. Отправка информационных писем на адрес электронной почты
                            </p>

                            <p>7. Условия обработки персональных данных</p>

                            <p>
                                7.1. Обработка персональных данных осуществляется с согласия
                                субъекта персональных данных на обработку его персональных данных.
                            </p>
                            <p>
                                7.2. Обработка персональных данных необходима для достижения целей,
                                предусмотренных международным договором Российской Федерации или
                                законом, для осуществления возложенных законодательством Российской
                                Федерации на оператора функций, полномочий и обязанностей.
                            </p>
                            <p>
                                7.3. Обработка персональных данных необходима для осуществления
                                правосудия, исполнения судебного акта, акта другого органа или
                                должностного лица, подлежащих исполнению в соответствии с
                                законодательством Российской Федерации об исполнительном
                                производстве.
                            </p>
                            <p>
                                7.4. Обработка персональных данных необходима для исполнения
                                договора, стороной которого либо выгодоприобретателем или
                                поручителем по которому является субъект персональных данных, а
                                также для заключения договора по инициативе субъекта персональных
                                данных или договора, по которому субъект персональных данных будет
                                являться выгодоприобретателем или поручителем.
                            </p>
                            <p>
                                7.5. Обработка персональных данных необходима для осуществления прав
                                и законных интересов оператора или третьих лиц либо для достижения
                                общественно значимых целей при условии, что при этом не нарушаются
                                права и свободы субъекта персональных данных.
                            </p>
                            <p>
                                7.6. Осуществляется обработка персональных данных, доступ
                                неограниченного круга лиц к которым предоставлен субъектом
                                персональных данных либо по его просьбе (далее — общедоступные
                                персональные данные).
                            </p>
                            <p>
                                7.7. Осуществляется обработка персональных данных, подлежащих
                                опубликованию или обязательному раскрытию в соответствии с
                                федеральным законом.
                            </p>
                            <p>
                                8. Порядок сбора, хранения, передачи и других видов обработки
                                персональных данных
                            </p>

                            <p>
                                Безопасность персональных данных, которые обрабатываются Оператором,
                                обеспечивается путем реализации правовых, организационных и
                                технических мер, необходимых для выполнения в полном объеме
                                требований действующего законодательства в области защиты
                                персональных данных.
                            </p>
                            <p>
                                8.1. Оператор обеспечивает сохранность персональных данных и
                                принимает все возможные меры, исключающие доступ к персональным
                                данным неуполномоченных лиц.
                            </p>
                            <p>
                                8.2. Персональные данные Пользователя никогда, ни при каких условиях
                                не будут переданы третьим лицам, за исключением случаев, связанных с
                                исполнением действующего законодательства либо в случае, если
                                субъектом персональных данных дано согласие Оператору на передачу
                                данных третьему лицу для исполнения обязательств по
                                гражданско-правовому договору.
                            </p>
                            <p>
                                8.3. В случае выявления неточностей в персональных данных,
                                Пользователь может актуализировать их самостоятельно, путем
                                направления Оператору уведомление на адрес электронной почты
                                Оператора elixiroom@yandex.ru с пометкой «Актуализация персональных
                                данных».
                            </p>
                            <p>
                                8.4. Срок обработки персональных данных определяется достижением
                                целей, для которых были собраны персональные данные, если иной срок
                                не предусмотрен договором или действующим законодательством.
                            </p>
                            <p>
                                Пользователь может в любой момент отозвать свое согласие на
                                обработку персональных данных, направив Оператору уведомление
                                посредством электронной почты на электронный адрес Оператора
                                elixiroom@yandex.ru с пометкой «Отзыв согласия на обработку
                                персональных данных».
                            </p>
                            <p>
                                8.5. Вся информация, которая собирается сторонними сервисами, в том
                                числе платежными системами, средствами связи и другими поставщиками
                                услуг, хранится и обрабатывается указанными лицами (Операторами) в
                                соответствии с их Пользовательским соглашением и Политикой
                                конфиденциальности. Субъект персональных данных и/или с указанными
                                документами. Оператор не несет ответственность за действия третьих
                                лиц, в том числе указанных в настоящем пункте поставщиков услуг.
                            </p>
                            <p>
                                8.6. Установленные субъектом персональных данных запреты на передачу
                                (кроме предоставления доступа), а также на обработку или условия
                                обработки (кроме получения доступа) персональных данных, разрешенных
                                для распространения, не действуют в случаях обработки персональных
                                данных в государственных, общественных и иных публичных интересах,
                                определенных законодательством РФ.
                            </p>
                            <p>
                                8.7. Оператор при обработке персональных данных обеспечивает
                                конфиденциальность персональных данных.
                            </p>
                            <p>
                                8.8. Оператор осуществляет хранение персональных данных в форме,
                                позволяющей определить субъекта персональных данных, не дольше, чем
                                этого требуют цели обработки персональных данных, если срок хранения
                                персональных данных не установлен федеральным законом, договором,
                                стороной которого, выгодоприобретателем или поручителем по которому
                                является субъект персональных данных.
                            </p>
                            <p>
                                8.9. Условием прекращения обработки персональных данных может
                                являться достижение целей обработки персональных данных, истечение
                                срока действия согласия субъекта персональных данных, отзыв согласия
                                субъектом персональных данных или требование о прекращении обработки
                                персональных данных, а также выявление неправомерной обработки
                                персональных данных.
                            </p>
                            <p>
                                9. Перечень действий, производимых Оператором с полученными
                                персональными данными
                            </p>

                            <p>
                                9.1. Оператор осуществляет сбор, запись, систематизацию, накопление,
                                хранение, уточнение (обновление, изменение), извлечение,
                                использование, передачу (распространение, предоставление, доступ),
                                обезличивание, блокирование, удаление и уничтожение персональных
                                данных.
                            </p>
                            <p>
                                9.2. Оператор осуществляет автоматизированную обработку персональных
                                данных с получением и/или передачей полученной информации по
                                информационно-телекоммуникационным сетям или без таковой.
                            </p>
                            <p>10. Трансграничная передача персональных данных</p>

                            <p>
                                10.1. Оператор до начала осуществления деятельности по
                                трансграничной передаче персональных данных обязан уведомить
                                уполномоченный орган по защите прав субъектов персональных данных о
                                своем намерении осуществлять трансграничную передачу персональных
                                данных (такое уведомление направляется отдельно от уведомления о
                                намерении осуществлять обработку персональных данных).
                            </p>
                            <p>
                                10.2. Оператор до подачи вышеуказанного уведомления, обязан получить
                                от органов власти иностранного государства, иностранных физических
                                лиц, иностранных юридических лиц, которым планируется трансграничная
                                передача персональных данных, соответствующие сведения.
                            </p>
                            <p>11. Конфиденциальность персональных данных</p>

                            <p>
                                Оператор и иные лица, получившие доступ к персональным данным,
                                обязаны не раскрывать третьим лицам и не распространять персональные
                                данные без согласия субъекта персональных данных, если иное не
                                предусмотрено федеральным законом.
                            </p>
                            <p>12. Заключительные положения</p>

                            <p>
                                12.1. Пользователь может получить любые разъяснения по интересующим
                                вопросам, касающимся обработки его персональных данных, обратившись
                                к Оператору с помощью электронной почты elixiroom@yandex.ru.
                            </p>
                            <p>
                                12.2. В данном документе будут отражены любые изменения политики
                                обработки персональных данных Оператором. Политика действует
                                бессрочно до замены ее новой версией.
                            </p>
                            <p>
                                12.3. Актуальная версия Политики в свободном доступе расположена в
                                сети Интернет по адресу https://elixiroom.ru/documents?block=policy.
                            </p>
                        </div>

                        <span
                            style={{ display: 'block', width: 10, height: 10, marginBottom: '8em' }}
                            data-block='return'
                        />
                        {/* <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br /> */}
                        <h2>Правила возврата товара</h2>
                        <ul>
                            <li>
                                Согласно Постановлению Правительства №2463 от 31.12.2020 «Об
                                утверждении правил продажи товаров по договору розничной
                                купли-продажи, перечня товаров длительного пользования, на которые
                                не распространяется требование потребителя о безвозмездном
                                предоставлении ему товара, обладающего этими же основными
                                потребительскими свойствами, на период ремонт или замены такого
                                товара, и перечня непродовольственных товаров надлежащего качества,
                                не подлежащих обмену, а также о внесении изменений в некоторые акты
                                Правительства РФ, парфюмерно-косметические товары надлежащего
                                качества не подлежат возврату или обмену.
                            </li>
                            <li>
                                Если вы получили Товар ненадлежащего качества (товар в поврежденной,
                                смятой упаковке, с нарушенной слюдой, с подтеками, с видимыми
                                сколами или повреждениями, с осадком), то такой Товар подлежит
                                обмену или возврату с компенсацией оплаченной стоимости за
                                возвращаемый Товар. Для получения обмена или компенсации необходимо:
                                <ol>
                                    <li>
                                        Направить по электронному адресу{' '}
                                        <a href='mailto:elixiroom@yandex.ru'>elixiroom@yandex.ru</a>{' '}
                                        заявление на обмен или возврат некачественного товара.
                                    </li>
                                    <li>Бланк заявления можно скачать по ссылке.</li>
                                    <li>
                                        К заявлению приложить также фотографии упаковки со всеми
                                        этикетками и повреждениями (при наличии) и самого
                                        поврежденного/не соответствующего заявленному Товару
                                    </li>
                                    <li>
                                        В заявлении также необходимо указать номер заказа,
                                        контактные данные Клиента/Потребителя и подробное описание
                                        причины возврата.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                Рассмотрение претензии осуществляется в течение 10 дней с момента ее
                                получения. Для принятия решения о возврате Товара Вам будет
                                необходимо предъявить сам Товар, направив его по адресу,
                                направленному в ответном письме, и приложив сопроводительные
                                документы к Заказу (заявление на возврат).
                            </li>
                            <li>
                                Денежные средства, оплаченные за Товар, и почтовые расходы (только в
                                случае возврата Товара ненадлежащего качества) на возврат Товара
                                будут возвращены на Ваш банковский расчетный счет в течение 10 дней
                                с момента получения Заявления на возврат и возвращенного Товара. В
                                случае не подтверждения брака, расходы на возврат Товара надлежащего
                                качества несет Клиент и Продавцом не возмещаются.
                            </li>
                            <li>
                                При получении заказа курьерской доставкой и обнаружении Товара
                                ненадлежащего качества Вам необходимо оформить документ на возврат
                                (накладная), заполнив соответствующие поля в накладной с указанием
                                всех выявленных недостатков и вернуть Товар курьеру вместе с
                                заполненным и подписанным документом. Денежные средства за Товар,
                                если заказ был оплачен, будут возвращены в течение 10 рабочих дней
                                (банковских дней) с момента получения возвращенного Товара
                                Продавцом.
                            </li>
                            <li>
                                Денежные средства подлежат возврату следующими способами:
                                <ol>
                                    <li>
                                        при оплате Заказа с использованием банковской карты,
                                        денежные средства подлежат возврату только на счет
                                        банковской карты, с использованием которой была произведена
                                        оплата.
                                    </li>
                                    <li>
                                        при оплате Заказа наличными денежными средствами, денежные
                                        средства подлежат возврату на банковский счет, указанный
                                        Клиентом в заявлении на возврат денежных средств.
                                    </li>
                                </ol>
                            </li>
                        </ul>
                        <span
                            style={{ display: 'block', width: 10, height: 10, marginBottom: '8em' }}
                            data-block='loyalty'
                        />
                        {/* <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br /> */}
                        <h2>О программе лояльности</h2>
                        <p>
                            Для участия в программе вам необходимо зарегистрироваться на сайте{' '}
                            <a href='https://elixiroom.wallet.cw.marketing'>
                                https://elixiroom.wallet.cw.marketing
                            </a>
                            .
                        </p>
                        <p>При регистрации вы получаете 300 приветственных бонусов.</p>
                        <p>
                            За покупки в оффлайн или онлайн магазине Elixiroom вам начисляется
                            кэшбэк в виде бонусов в размере:
                        </p>
                        <ul>
                            <li>3% - назначается сразу при регистрации в программе;</li>
                            <li>5% - при совершении покупок на общую сумму от 30000₽;</li>
                            <li>7% - при совершении покупок на общую сумму от 70000₽;</li>
                            <li>
                                10% + VIP статус - при совершении покупок на общую сумму от 100000₽.
                            </li>
                        </ul>
                        <p>
                            VIP статус предоставляет доступ к закрытым распродажам, предзаказу
                            новинок, бесплатной доставке и другим привилегиям. Об этом мы сообщим
                            вам в индивидуальной рассылке.
                        </p>
                        <p>1 бонус = 1 рубль.</p>
                        <p>Вы можете оплатить бонусами до 30% от суммы покупки.</p>
                        <p>
                            Новая программа лояльности действует с 09.12.2022. С этой даты, при
                            следующей покупке, вы автоматически перейдете на новую программу
                            лояльности, и вся информация о ваших бонусах отобразится на вашей карте.
                            Все накопленные вами до 09.12.2022 бонусы также сохраняются и
                            автоматически перенесутся на новую карту.
                        </p>
                        <span data-block='certs' />
                        {/*<br/><br/>*/}
                        {/*<h2>Сертификаты</h2>*/}
                        {/*<a href="https://drive.google.com/file/d/1REtbYyO1OozFqjkrMEUg2hEuiv7uvdfo/view" target="_blank" rel="noopener noreferrer nofollow">Сертификаты</a>*/}
                    </div>
                </div>
            </div>
        </Page>
    )
}

export default Documents
